import styled from "styled-components";
import { V3Body } from "../Typography";
import { EmbedWithClamp } from "./V3EmbedCollection.styles";
import { ClampMixin } from "../ReusableStyledComponents/ClampMixin";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";

export const V3EmbedContentListItemWrapper = styled.div`
    display: flex;

    > div {
        &:first-child {
            margin-right: 16px;
            flex-shrink: 0;
        }

        &:nth-child(2) {
            max-width: calc(100% - 106px);
        }
    }
`;

export const V3EmbedContentListItemImage = styled.div<{ $imageSrc: string | null }>`
    width: 90px;
    height: 58px;
    border-radius: 6px;
    background: ${({ theme }) => `${theme.v3.colors.grey96}`};
    background-image: url(${({ $imageSrc }) => $imageSrc ? $imageSrc : null});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
`;

const UserThemableV3EmbedContentListItemImageTitle= styled(V3Body)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedContentListItemImageTitle = styled(UserThemableV3EmbedContentListItemImageTitle) <EmbedWithClamp>`
    ${ClampMixin};
`;